import axios from "axios";
import { notification } from "antd";
const baseUrl = process.env.REACT_APP_API_URL;

const config = {
  headers: { Authorization: "" },
};

export const createSubscription = (data) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
      config.headers['Content-Type'] = 'application/json';
      const res = await axios.post(`${baseUrl}/payments/subsription`, data, config);
      alert("----- Transaction successful");
      // dispatch({
      //   type: "get-projects",
      //   payload: res.data.data,
      // });
    } catch (error) {
      console.log("----- error", error);
      alert("----- Transaction failed");
      // dispatch({
      //   type: "error",
      //   payload: error,
      // });
    }
  };
};

export const updateSubscription = (data) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
      config.headers['Content-Type'] = 'application/json';
      const res = await axios.post(`${baseUrl}/payments/subsription/update`, data, config);
      // dispatch({
      //   type: "get-projects",
      //   payload: res.data.data,
      // });
      return res;
    } catch (error) {
      console.log("----- error", error);
      // dispatch({
      //   type: "error",
      //   payload: error,
      // });
    }
  };
};


export const cancelSubscription = (data, callback) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
      const res = await axios.post(`${baseUrl}/payments/subsription/cancel`, data, config);
      if(callback) {
        callback();
      }
    } catch (error) {
      console.log("----- error", error);
    }
  }
}